import axios from '../../axios'

/*
 * 用户数据接口
 */

// 获取用户列表
export const getUserList = (data) => {
    return axios({
        url: '/api/admin/user',
        method: 'get',
        data
    })
}

// 新增用户信息
export const saveUser = (data) => {
    return axios({
        url: '/api/admin/user',
        method: 'post',
        data
    })
}
// 批量新增导入用户信息
export const importUser = (data) => {
    return axios({
        url: '/api/admin/user/channel/import',
        method: 'post',
        data
    })
}
// 编辑用户信息
export const updateUser = (data) => {
    return axios({
        url: '/api/admin/user',
        method: 'put',
        data
    })
}

// 删除用户列表
export const deleteUser = (data) => {
    return axios({
        url: '/api/admin/user',
        method: 'delete',
        data
    })
}

// 获取角色列表
export const getRoleList = (data) => {
    return axios({
        url: '/api/admin/roleList',
        method: 'get',
        data
    })
}

// 重置密码
export const resetPwd = (data) => {
    return axios({
        url: '/api/admin/resetPwd',
        method: 'post',
        data
    })
}

// 获取外呼token
export const getHotLine = (data) => {
    return axios({
        url: '/api/admin/user/call/token/exchange',
        method: 'get',
        data
    })
}

// 获取外呼token
export const refreshHotLine = (data) => {
    return axios({
        url: '/api/admin/user/call/token/refresh',
        method: 'get',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/sys/user.js